import { NavEntryType, NavGroupType, RoleType } from '@src/types/main';

export const filterNavEntries = (
  entries: NavEntryType[],
  role: RoleType
): NavEntryType[] => {
  const result = entries.filter((entry) => entry.allowedRoles.includes(role));
  return result;
};

export const filterByRole = (
  navItems: NavGroupType[],
  role: RoleType
): NavGroupType[] => {
  return navItems.map((navItem) => ({
    ...navItem,
    entries: navItem.entries
      .map((entry) => {
        if (entry.type === 'subGroup') {
          return {
            ...entry,
            entries: filterNavEntries(entry.entries, role),
          };
        }
        const filteredEntry = filterNavEntries([entry], role)[0];
        return filteredEntry || null;
      })
      .filter((entry) => entry !== null),
  }));
};

export const removeEmptyGroupsAndSubGroups = (
  navItems: NavGroupType[]
): NavGroupType[] => {
  return navItems
    .map((navItem) => ({
      ...navItem,
      entries: navItem.entries.filter((entry) => {
        if (entry.type === 'subGroup') {
          return entry.entries.length > 0;
        }
        return entry !== null;
      }),
    }))
    .filter((navItem) => navItem.entries.length > 0);
};

export const getAllowedRoutes = (
  navItems: NavGroupType[],
  role: RoleType
): NavGroupType[] => {
  const filteredNavItems = filterByRole(navItems, role);
  return removeEmptyGroupsAndSubGroups(filteredNavItems);
};
